//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
SPLM.AME.AmeElectricalConnectionPotentialType = Object.freeze({
    "L" : "L", "N" : "N", "Pe" : "Pe", "LPlus" : "LPlus", "LDash" : "LDash", "Shield" : "Shield", "Undefined" : "Undefined", "Invalid" : "Invalid"});

SPLM.AME.AmeOpticalConnectionFiberType = Object.freeze({
    "SingleMode" : "SingleMode", "MultiMode" : "MultiMode", "Undefined" : "Undefined", "Invalid" : "Invalid"});

SPLM.AME.AmeFluidicConnectionOccupancyType = Object.freeze({
    "SupplyLine" : "SupplyLine", "ReturnLine" : "ReturnLine", "PilotLine" : "PilotLine", "DrainLine" : "DrainLine", "FlushingLine" : "FlushingLine", "BleedLine" : "BleedLine", "Undefined" : "Undefined", "Invalid" : "Invalid"});

export default SPLM;